include ../../../../common/primary/icon/icon.mixin.pug

.fp-toast(:class='`-${toast.type}`' data-test='toast' @mouseenter='enter' @mouseleave='leave')
  .fp-toast--message
    i.fp-icon.-s18(:class='[`-color-${toast.type}`, icon]')
    span.fp-text {{ toast.message }}
  .fp-toast--action(data-test='toast.close' @click='close')
    +fp-icon('close', {size: '16'})
